import { defineStore } from "pinia"
import { GalleryService } from "@/store/services/gallery.service.js"
import { storeToRefs } from "pinia"

export const galleryStore = defineStore("gallery", {
  state: () => {
    return {
      gallery: "",
    }
  },
  getters: {
    getGallerys: (state) => state.gallery,
  },
  actions: {
    getGallerysAction() {
      if (this.gallery != "") return this.gallery
      EventSys.$emit("gallery_loading")
      GalleryService.list().then(({ data }) => {
        EventSys.$emit("gallery_loaded")
        this.gallery = data
      })
    },
  },
})
